import {
  TIPOS_CITA_CONTACTOS_SIEMPRE_VISIBLES,
  TIPOS_CITA_SIN_CONTACTOS_NI_TEAMS,
  USO_CITA_LINEA_AT
} from 'src/app/common/scheduling-constants';

export interface EntradaVisibilidadContactos {
  tipoCitaId: number;
  /** DSUSO_CITA del tipo seleccionado (TPSC_TIPOS_DE_CITAS). */
  dsusoCita?: string | null;
  snEnlaceTeams?: string | null;
}

export interface VisibilidadContactos {
  mostrarContactos: boolean;
  mostrarEnlaceTeams: boolean;
  /** Valor de Enlace Teams que debe quedar en el formulario y viajar en el payload. */
  snEnlaceTeams: 'S' | 'N';
}

/**
 * Regla única de visibilidad de Contactos y Enlace Teams según el tipo de cita.
 *
 * - Línea AT (DSUSO_CITA = 'LINEAAT') y CAMPO: Contactos siempre visibles, Teams visible.
 *   Legacy CrearCitaAdministrativaViewImpl L1541-1545 (Línea AT) y L1553-1555 (CAMPO).
 * - INFORME: Contactos y Teams ocultos; Teams forzado a 'N'.
 *   Legacy ServiceAppointmentInterfaceImpl L1879-1880 (HU-175) y L1781-1782 (oculta Teams).
 * - Demás tipos: Teams visible; Contactos solo con Teams = 'S'.
 *   Legacy CrearCitaAdministrativaViewImpl L1526-1533 y validarTeams() L2185-2199.
 */
export function resolverVisibilidadContactos(
  entrada: EntradaVisibilidadContactos
): VisibilidadContactos {
  const snEnlaceTeams = entrada.snEnlaceTeams === 'S' ? 'S' : 'N';
  const esLineaAt = entrada.dsusoCita?.toUpperCase() === USO_CITA_LINEA_AT;

  if (
    esLineaAt ||
    TIPOS_CITA_CONTACTOS_SIEMPRE_VISIBLES.includes(entrada.tipoCitaId)
  ) {
    return { mostrarContactos: true, mostrarEnlaceTeams: true, snEnlaceTeams };
  }

  if (TIPOS_CITA_SIN_CONTACTOS_NI_TEAMS.includes(entrada.tipoCitaId)) {
    return {
      mostrarContactos: false,
      mostrarEnlaceTeams: false,
      snEnlaceTeams: 'N'
    };
  }

  return {
    mostrarContactos: snEnlaceTeams === 'S',
    mostrarEnlaceTeams: true,
    snEnlaceTeams
  };
}
